import { createContext } from 'react';

const SceneFlexLayoutContext = createContext(null);

export { SceneFlexLayoutContext };
//# sourceMappingURL=SceneFlexLayoutContext.js.map
